import { IRowElement, IColumnElement } from '@doseme/cohesive-ui'
import moment from 'moment'

import { ISubscription, IChangedSubscription } from '../../../types/subscription'
import { IEntityHashMap } from 'flux-entities'

export interface IHospitalSubscriptions {
  currentSubscriptions: ISubscription[]
  expiredSubscriptions: ISubscription[]
}

export interface IHospitalChangedSubscriptions {
  currentSubscriptions: IEntityHashMap<IChangedSubscription>
  expiredSubscriptions: IEntityHashMap<IChangedSubscription>
}

const formatSubscriptionRows = (
  subscriptions: ISubscription[],
  formatColumn: (sub: ISubscription) => IColumnElement[]
): IRowElement[] => {
  return subscriptions.reduce<IRowElement[]>((acc, curr) => {
    const displayId = curr.id || ''
    return [
      ...acc,
      {
        id: displayId,
        columns: formatColumn(curr),
        className: curr.end.isBefore(moment()) ? 'subscription-expired' : ''
      }
    ]
  }, [])
}

const formatChangedSubscriptionRows = (
  subscriptions: IEntityHashMap<IChangedSubscription>,
  formatColumn: (idOfSubWithPlan: string, subscriptions: IEntityHashMap<IChangedSubscription>) => IColumnElement[]
): IRowElement[] => {
  return Object.keys(subscriptions).reduce<IRowElement[]>((acc, curr) => {
    const displayId = subscriptions[curr].id || ''
    return [
      ...acc,
      {
        id: displayId,
        columns: formatColumn(curr, subscriptions),
        className: subscriptions[curr].end.isBefore(moment()) ? 'subscription-expired' : ''
      }
    ]
  }, [])
}

/**
 * Splits an array of subscriptions into expired and current subscriptions.
 */
const splitCurrentAndExpiredSubscriptions = (subscriptions: ISubscription[]): IHospitalSubscriptions => {
  return subscriptions.reduce<IHospitalSubscriptions>((acc, curr) => {
    if (curr.end.isBefore(moment())) {
      acc.expiredSubscriptions.push(curr)
      return acc
    }

    acc.currentSubscriptions.push(curr)
    return acc
  }, { currentSubscriptions: [], expiredSubscriptions: [] })
}

/**
 * Splits an array of changed subscriptions into expired and current subscriptions.
 */
const splitChangedSubscriptions = (
  subscriptions: IEntityHashMap<IChangedSubscription>
): IHospitalChangedSubscriptions => {
  return Object.keys(subscriptions).reduce<IHospitalChangedSubscriptions>((acc, curr) => {

    if (subscriptions[curr].end.isBefore(moment())) {
      acc.expiredSubscriptions[curr] = subscriptions[curr]
      return acc
    }

    acc.currentSubscriptions[curr] = subscriptions[curr]
    return acc
  }, { currentSubscriptions: {}, expiredSubscriptions: {} })
}

export {
  formatSubscriptionRows,
  formatChangedSubscriptionRows,
  splitCurrentAndExpiredSubscriptions,
  splitChangedSubscriptions,
}
